// Mock data for Book Publishing Company Website

export const companyInfo = {
  name: "Book Creation Studio",
  tagline: "Transform Your Story Into A Masterpiece",
  mission: "We are dedicated to bringing authors' visions to life through comprehensive publishing services. From concept to bookshelf, we handle every aspect of the publishing journey with professionalism and care.",
  email: "support@bookcreationstudio.com",
  phone: "+1 (888) 655 0682",
  address: "One Wilshire Building, 624 S Grand Ave Floor 21, Los Angeles, CA 90017"
};

export const services = [
  {
    id: 1,
    title: "Book Writing",
    slug: "book-writing",
    description: "Expert ghostwriting for all genres. We transform your vision into compelling narratives that captivate readers.",
    icon: "PenTool",
    gifUrl: "https://customer-assets.emergentagent.com/job_bookpub-service/artifacts/daw30gby_Book%20Writing.gif",
    features: ["Fiction & Non-Fiction", "Memoirs & Biographies", "Business Books", "Self-Help Guides"],
    process: "Consultation → Outline → Writing → Revisions → Final Draft",
    hero: {
      title: "Shaping Iconic Narratives for Global Impact",
      subtitle: "World-class writers crafting compelling stories that resonate with readers.",
      highlights: [
        "Tailored book writing services, turning your ideas into captivating narratives",
        "Competitive pricing with a focus on your vision and 100% satisfaction",
        "Expert ghostwriters across all genres"
      ],
      backgroundImage: "https://images.unsplash.com/photo-1639343062512-d73d04dbcde0?w=1920"
    },
    processSteps: [
      {
        number: "01",
        title: "Consultation & Outline Creation",
        description: "We begin with a clear concept and structured outline. Think of it as your roadmap, ensuring a smooth flow for your story."
      },
      {
        number: "02",
        title: "Writing & Development",
        description: "Our expert writers bring your vision to life, crafting compelling narratives that engage readers from start to finish."
      },
      {
        number: "03",
        title: "Revisions & Finalization",
        description: "We refine your manuscript with multiple revision rounds, ensuring every word reflects your unique voice and vision."
      }
    ],
    benefits: [
      {
        title: "Time Freedom",
        description: "You focus on what matters; ideas, while our writers handle the writing.",
        icon: "Clock"
      },
      {
        title: "Expertise Advantage",
        description: "Access seasoned professionals in genres from memoirs to business writing.",
        icon: "Award"
      },
      {
        title: "Proven Results",
        description: "Our authors become published, with polished, compelling manuscripts.",
        icon: "TrendingUp"
      },
      {
        title: "Stress Free Process",
        description: "From outline to final draft, we manage every step so you can relax.",
        icon: "CheckCircle"
      }
    ]
  },
  {
    id: 2,
    title: "Book Publishing",
    slug: "book-publishing",
    description: "Full publishing services with ISBN registration, formatting, and worldwide distribution to all major platforms.",
    icon: "BookOpen",
    gifUrl: "https://customer-assets.emergentagent.com/job_bookpub-service/artifacts/3r60pv54_Book%20Publishing.gif",
    features: ["ISBN Registration", "Professional Formatting", "Global Distribution", "Rights Management"],
    process: "Manuscript Review → Editing & Proofreading → Design & Formatting → Publishing & Distribution",
    hero: {
      title: "Transform Your Manuscript Into a Published Masterpiece",
      subtitle: "Professional publishing services that bring your book to readers worldwide.",
      highlights: [
        "Complete publishing solution from ISBN to distribution",
        "Access to major platforms including Amazon, Barnes & Noble, and more",
        "Expert guidance through every step of the publishing journey"
      ],
      backgroundImage: "https://images.unsplash.com/photo-1513185041617-8ab03f83d6c5?w=1920"
    },
    processSteps: [
      {
        number: "01",
        title: "Manuscript Review & Planning",
        description: "We thoroughly assess your manuscript, understanding your vision and goals. Our team crafts a customized publishing strategy tailored to your book's unique requirements and target audience."
      },
      {
        number: "02",
        title: "Editing & Proofreading",
        description: "Our expert editors meticulously review your manuscript, refining grammar, structure, and flow. We ensure your content is polished, professional, and error-free before moving forward."
      },
      {
        number: "03",
        title: "Design & Formatting",
        description: "Professional formatting for both print and digital editions, stunning cover design, and ISBN registration. We ensure your book meets industry standards and looks exceptional on all platforms."
      },
      {
        number: "04",
        title: "Publishing & Distribution",
        description: "We handle everything from printing to global distribution, bringing your book to readers worldwide. Your book goes live on Amazon, Barnes & Noble, and all major retailers with ongoing support."
      }
    ],
    benefits: [
      {
        title: "Global Reach",
        description: "Your book available on Amazon, Barnes & Noble, and international platforms.",
        icon: "Globe"
      },
      {
        title: "Full Rights Retention",
        description: "You maintain complete ownership and control of your intellectual property.",
        icon: "Shield"
      },
      {
        title: "Professional Standards",
        description: "Industry-standard formatting and compliance with all major retailers.",
        icon: "Award"
      },
      {
        title: "Ongoing Support",
        description: "We're here to help long after your book is published.",
        icon: "Users"
      }
    ]
  },
  {
    id: 3,
    title: "Book Marketing",
    slug: "book-marketing",
    description: "Strategic campaigns across social media, email, and press releases to maximize your book's reach and sales.",
    icon: "TrendingUp",
    gifUrl: "https://customer-assets.emergentagent.com/job_bookpub-service/artifacts/v6da3wsg_Book%20Marketing.gif",
    features: ["Social Media Campaigns", "Email Marketing", "Press Releases", "Book Launch Events"],
    process: "Strategy Development → Campaign Creation → Launch → Performance Tracking",
    hero: {
      title: "Amplify Your Book's Reach and Impact",
      subtitle: "Strategic marketing that turns readers into fans and books into bestsellers.",
      highlights: [
        "Customized marketing strategies tailored to your genre and audience",
        "Multi-channel campaigns across social media, email, and press",
        "Data-driven approach with measurable results"
      ],
      backgroundImage: "https://images.unsplash.com/photo-1667039487297-be4ae76e6df1?w=1920"
    },
    processSteps: [
      {
        number: "01",
        title: "Strategy Development",
        description: "We analyze your target audience and create a comprehensive marketing plan tailored to your book's unique selling points."
      },
      {
        number: "02",
        title: "Campaign Execution",
        description: "Launch multi-channel campaigns including social media, email marketing, press releases, and promotional events."
      },
      {
        number: "03",
        title: "Performance & Optimization",
        description: "Track campaign performance and optimize strategies to maximize your book's visibility and sales."
      }
    ],
    benefits: [
      {
        title: "Targeted Reach",
        description: "Connect with readers who are genuinely interested in your genre.",
        icon: "Target"
      },
      {
        title: "Multi-Channel Strategy",
        description: "Comprehensive campaigns across social media, email, and traditional media.",
        icon: "Share2"
      },
      {
        title: "Measurable Results",
        description: "Track your campaign performance with detailed analytics and reporting.",
        icon: "BarChart"
      },
      {
        title: "Brand Building",
        description: "Establish yourself as an author brand that readers trust and follow.",
        icon: "Zap"
      }
    ]
  },
  {
    id: 4,
    title: "Audiobook Production",
    slug: "audiobook-production",
    description: "Professional audiobook production with experienced narrators, studio recording, and distribution to major platforms.",
    icon: "Mic",
    gifUrl: "https://customer-assets.emergentagent.com/job_bookpub-service/artifacts/3rg76y84_Audiobook.gif",
    features: ["Professional Narration", "Studio Recording", "Audio Editing", "Platform Distribution"],
    process: "Narration → Recording → Editing → Mastering → Distribution",
    hero: {
      title: "Bring Your Story to Life Through Sound",
      subtitle: "Professional audiobook production that captivates listeners.",
      highlights: [
        "Experienced narrators who bring your characters to life",
        "Studio-quality recording and professional audio engineering",
        "Distribution to Audible, Apple Books, and major audiobook platforms"
      ],
      backgroundImage: "https://images.unsplash.com/photo-1590602846989-e99596d2a6ee?w=1920"
    },
    processSteps: [
      {
        number: "01",
        title: "Narrator Selection & Recording",
        description: "Choose from our roster of professional narrators and begin studio recording with state-of-the-art equipment."
      },
      {
        number: "02",
        title: "Audio Editing & Mastering",
        description: "Our sound engineers edit and master your audiobook to industry standards for optimal listening experience."
      },
      {
        number: "03",
        title: "Distribution & Delivery",
        description: "We distribute your audiobook to Audible, iTunes, and other major platforms worldwide."
      }
    ],
    benefits: [
      {
        title: "Professional Narrators",
        description: "Access to experienced voice actors who bring authenticity to your story.",
        icon: "Mic"
      },
      {
        title: "Studio Quality",
        description: "Crystal-clear audio recorded in professional studios with top-tier equipment.",
        icon: "Radio"
      },
      {
        title: "Wide Distribution",
        description: "Your audiobook available on Audible, Apple Books, and more.",
        icon: "Headphones"
      },
      {
        title: "Listener Engagement",
        description: "Reach new audiences who prefer audio content over traditional reading.",
        icon: "Users"
      }
    ]
  },
  {
    id: 5,
    title: "Book Editing",
    slug: "book-editing",
    description: "Expert editing services including developmental editing, copyediting, and proofreading for polished manuscripts.",
    icon: "FileEdit",
    gifUrl: "https://customer-assets.emergentagent.com/job_bookpub-service/artifacts/6fqpo795_Book%20Editing.gif",
    features: ["Developmental Editing", "Copyediting", "Proofreading", "Style Consistency"],
    process: "Initial Review → Editing Rounds → Author Collaboration → Final Polish",
    hero: {
      title: "Polish Your Manuscript to Perfection",
      subtitle: "Expert editing services that elevate your writing to professional standards.",
      highlights: [
        "Comprehensive editing from developmental to proofreading",
        "Experienced editors across all genres and writing styles",
        "Multiple revision rounds ensuring manuscript excellence"
      ],
      backgroundImage: "https://images.unsplash.com/photo-1581431886288-e216ea4ccf3f?w=1920"
    },
    processSteps: [
      {
        number: "01",
        title: "Initial Review & Assessment",
        description: "We thoroughly review your manuscript to identify areas for improvement in structure, flow, and content."
      },
      {
        number: "02",
        title: "Editing & Collaboration",
        description: "Our editors work closely with you through multiple rounds of edits, refining your manuscript's clarity and impact."
      },
      {
        number: "03",
        title: "Final Polish & Proofreading",
        description: "Meticulous proofreading ensures your manuscript is error-free and ready for publication."
      }
    ],
    benefits: [
      {
        title: "Expert Editors",
        description: "Work with professionals who understand your genre and writing style.",
        icon: "UserCheck"
      },
      {
        title: "Comprehensive Service",
        description: "From developmental editing to final proofreading, we cover it all.",
        icon: "Layers"
      },
      {
        title: "Maintain Your Voice",
        description: "We enhance your writing while preserving your unique author voice.",
        icon: "MessageSquare"
      },
      {
        title: "Fast Turnaround",
        description: "Efficient editing process without compromising on quality.",
        icon: "Clock"
      }
    ]
  },
  {
    id: 6,
    title: "Book Printing",
    slug: "book-printing",
    description: "Premium printing with flexible options for print-on-demand or bulk orders. Fast delivery and quality guaranteed.",
    icon: "Printer",
    gifUrl: "https://customer-assets.emergentagent.com/job_bookpub-service/artifacts/mkr6zm0l_Book%20Printing.gif",
    features: ["Print-on-Demand", "Bulk Printing", "Premium Paper Quality", "Multiple Binding Options"],
    process: "File Preparation → Proof Review → Printing → Quality Check → Delivery",
    hero: {
      title: "Premium Quality Printing for Your Masterpiece",
      subtitle: "Professional printing services that bring your book to physical life.",
      highlights: [
        "High-quality printing with premium paper and binding options",
        "Flexible solutions from print-on-demand to bulk orders",
        "Fast turnaround with rigorous quality control"
      ],
      backgroundImage: "https://images.unsplash.com/photo-1693031630177-b897fb9d7154?w=1920"
    },
    processSteps: [
      {
        number: "01",
        title: "File Preparation & Proof",
        description: "We prepare your files for printing and provide a detailed proof for your review and approval."
      },
      {
        number: "02",
        title: "Printing & Quality Control",
        description: "Your books are printed using high-quality materials with multiple quality checks throughout the process."
      },
      {
        number: "03",
        title: "Delivery & Distribution",
        description: "We handle packaging and delivery, ensuring your books arrive in perfect condition."
      }
    ],
    benefits: [
      {
        title: "Premium Quality",
        description: "Superior paper quality and professional binding that readers will love.",
        icon: "Award"
      },
      {
        title: "Flexible Options",
        description: "Choose from print-on-demand or bulk printing based on your needs.",
        icon: "Settings"
      },
      {
        title: "Cost Effective",
        description: "Competitive pricing without compromising on quality.",
        icon: "DollarSign"
      },
      {
        title: "Fast Delivery",
        description: "Quick turnaround times to meet your publishing deadlines.",
        icon: "Truck"
      }
    ]
  },
  {
    id: 7,
    title: "Other Services",
    slug: "other-services",
    description: "Complete creative services including video trailers, web design, illustrations, and professional content writing.",
    icon: "Sparkles",
    gifUrl: "https://customer-assets.emergentagent.com/job_bookpub-service/artifacts/164u345i_Additional%20Services.gif",
    features: ["Book Video Trailers", "Website Design & SEO", "Custom Illustrations", "Articles Services", "Book Design", "Blog Writing", "Web Content Writing"],
    process: "Service Selection → Project Briefing → Creation → Review → Delivery",
    subServices: [
      {
        name: "Book Video Trailer",
        description: "Cinematic book trailers that capture attention",
        gifUrl: "https://customer-assets.emergentagent.com/job_bookpub-service/artifacts/daw30gby_Book%20Writing.gif"
      },
      {
        name: "Web Design & SEO",
        description: "Author websites optimized for search and conversions",
        gifUrl: "https://customer-assets.emergentagent.com/job_bookpub-service/artifacts/3r60pv54_Book%20Publishing.gif"
      },
      {
        name: "Illustration Services",
        description: "Custom illustrations for covers and interiors",
        gifUrl: "https://customer-assets.emergentagent.com/job_bookpub-service/artifacts/j1a1yaoa_Book%20Design.gif"
      },
      {
        name: "Articles Services",
        description: "Professional article writing and content creation",
        gifUrl: "https://customer-assets.emergentagent.com/job_bookpub-service/artifacts/am46oi0t_Articles.gif"
      },
      {
        name: "Book Design Services",
        description: "Eye-catching cover and interior design",
        gifUrl: "https://customer-assets.emergentagent.com/job_bookpub-service/artifacts/j1a1yaoa_Book%20Design.gif"
      },
      {
        name: "Blog Writing Services",
        description: "Engaging blog content for your author platform",
        gifUrl: "https://customer-assets.emergentagent.com/job_bookpub-service/artifacts/16v6fn6h_Blog%20Writing.gif"
      },
      {
        name: "Web Content Writing Service",
        description: "SEO-optimized website copy and content",
        gifUrl: "https://customer-assets.emergentagent.com/job_bookpub-service/artifacts/prgf71ka_Web%20Content%20Writing.gif"
      }
    ],
    hero: {
      title: "Complete Publishing Solutions Beyond the Book",
      subtitle: "Comprehensive services to enhance your author brand and book presence.",
      highlights: [
        "Professional book trailers that generate excitement and engagement",
        "Author websites with SEO optimization to build your online presence",
        "Custom illustrations and content writing for all your publishing needs"
      ]
    },
    processSteps: [
      {
        number: "01",
        title: "Service Selection & Consultation",
        description: "Choose from our range of services and discuss your specific requirements with our team."
      },
      {
        number: "02",
        title: "Creation & Development",
        description: "Our specialists work on your project, whether it's a video trailer, website, or custom illustrations."
      },
      {
        number: "03",
        title: "Review & Delivery",
        description: "We present the final product for your review and make any necessary adjustments before delivery."
      }
    ],
    benefits: [
      {
        title: "One-Stop Shop",
        description: "All your publishing needs handled by a single trusted team.",
        icon: "Package"
      },
      {
        title: "Brand Building",
        description: "Create a cohesive author brand across all platforms and materials.",
        icon: "Layers"
      },
      {
        title: "Marketing Edge",
        description: "Stand out with professional trailers and engaging web content.",
        icon: "TrendingUp"
      },
      {
        title: "Flexible Solutions",
        description: "Pick and choose services based on your specific needs and budget.",
        icon: "Sliders"
      }
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    author: "Sarah Mitchell",
    role: "Bestselling Author",
    content: "Book Creation Studio transformed my manuscript into a stunning book. Their attention to detail and professional approach made the entire process seamless.",
    rating: 5,
    service: "general"
  },
  {
    id: 2,
    author: "James Rodriguez",
    role: "Business Author",
    content: "The marketing team helped my book reach audiences I never thought possible. Sales exceeded expectations within the first month!",
    rating: 5,
    service: "book-marketing"
  },
  {
    id: 3,
    author: "Emily Chen",
    role: "Memoir Writer",
    content: "From ghostwriting to final print, every step was handled with care. I'm thrilled with the result and highly recommend their services.",
    rating: 5,
    service: "general"
  },
  {
    id: 4,
    author: "Rachel Foster",
    role: "Published Author",
    content: "I never thought my story would reach so many people. The ghostwriting team captured my voice perfectly and helped me create a book I'm truly proud of.",
    rating: 5,
    service: "book-writing"
  },
  {
    id: 5,
    author: "Tom Williams",
    role: "Fiction Author",
    content: "The editing and design team truly brought my book to life. I'm so proud of the final result, and the feedback has been amazing.",
    rating: 5,
    service: "book-editing"
  },
  {
    id: 6,
    author: "Lisa Martinez",
    role: "Self-Published Author",
    content: "I was overwhelmed by the self-publishing process, but their expert publishing services made the entire journey seamless and stress-free.",
    rating: 5,
    service: "book-publishing"
  },
  {
    id: 7,
    author: "David Chen",
    role: "Novelist",
    content: "The book cover design was stunning. It perfectly captured the essence of my story, and I've had so many readers tell me how much they love it!",
    rating: 5,
    service: "book-design"
  },
  {
    id: 8,
    author: "Michael Parker",
    role: "Published Author",
    content: "The audiobook narration brought my characters to life in ways I never imagined. The production quality is absolutely top-notch.",
    rating: 5,
    service: "audiobook-production"
  },
  {
    id: 9,
    author: "Amanda Roberts",
    role: "Self-Published Author",
    content: "The print quality exceeded my expectations. The books arrived quickly and looked absolutely professional. Highly recommend their printing services!",
    rating: 5,
    service: "book-printing"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Self-Publishing vs Traditional Publishing: Which Path is Right for You?",
    excerpt: "Understanding the key differences between self-publishing and traditional publishing to help you make an informed decision for your book.",
    date: "March 20, 2024",
    category: "Publishing",
    image: "https://images.unsplash.com/photo-1519682337058-a94d519337bc?w=800",
    author: "David Thompson",
    content: `Choosing between self-publishing and traditional publishing is one of the most important decisions you'll make as an author. Let's explore both paths to help you decide.

**Traditional Publishing**

Traditional publishing involves working with established publishing houses who handle everything from editing to distribution. Here's what you need to know:

*Pros:*
- Advance payments (though typically modest for first-time authors)
- Professional editing, design, and marketing team
- Bookstore distribution and industry connections
- Perceived prestige and credibility

*Cons:*
- Extremely competitive - less than 1% of manuscripts get accepted
- Loss of creative control over your work
- Lower royalties (typically 10-15% vs 70%+ with self-publishing)
- Very long timeline (often 1-2 years from acceptance to publication)
- You give up rights to your book
- Limited say in pricing, cover design, and marketing

**Self-Publishing**

Self-publishing puts you in complete control of your book's journey. This is where Book Creation Studio specializes in helping authors succeed:

*Pros:*
- Full creative control over every aspect of your book
- Higher royalties (70%+ on most platforms)
- Faster timeline - publish in months, not years
- Keep all rights to your work forever
- Set your own pricing strategy
- Direct relationship with readers
- Ability to make changes anytime
- No gatekeepers - your book reaches readers

*Cons:*
- Upfront investment in professional services (editing, design, etc.)
- You're responsible for quality control
- Need to handle or outsource marketing
- Limited access to traditional bookstores (though Amazon distribution is powerful)
- Must build your own author platform

**Why We Focus on Self-Publishing**

At Book Creation Studio, we specialize in self-publishing services because we believe authors deserve:
- Full ownership of their creative work
- Maximum profit from their book sales
- Complete control over their publishing timeline
- The freedom to make their own decisions

We provide all the professional services traditional publishers offer - expert editing, stunning cover design, professional formatting, and strategic marketing - but YOU keep the rights and the majority of profits.

**Making Your Decision**

Self-publishing is ideal if you:
- Want creative control and ownership
- Need to publish on your timeline
- Want higher royalties
- Have a platform or can build one
- Are entrepreneurial-minded

Traditional publishing might be worth pursuing if you:
- Have unlimited time to wait (years)
- Are willing to give up rights and control
- Have connections in the publishing industry
- Want the validation of a traditional publisher

**The Modern Reality**

Today's most successful authors often start with self-publishing. Many bestsellers began as self-published books. With professional services like ours, self-published books are indistinguishable from traditionally published ones in quality - but YOU control everything and earn significantly more per book sold.

**Ready to Start Your Self-Publishing Journey?**

Contact Book Creation Studio today. We'll guide you through every step of the process, from manuscript to bestseller, while you maintain complete ownership and control of your work.`
  },
  {
    id: 2,
    title: "10 Essential Tips for First-Time Authors",
    excerpt: "Starting your publishing journey? Here are the key things every new author should know before publishing their first book.",
    date: "March 15, 2024",
    category: "Writing Tips",
    image: "https://images.unsplash.com/photo-1455390582262-044cdead277a?w=800",
    author: "Sarah Mitchell",
    content: `Publishing your first book is an exciting milestone. Here are ten essential tips to help you navigate the journey successfully.

1. **Know Your Audience**: Understanding who you're writing for shapes everything from your writing style to your marketing approach.

2. **Professional Editing is Non-Negotiable**: Even the best writers need editors. Professional editing catches errors and improves clarity.

3. **Invest in a Quality Cover**: Your book cover is your first impression. Professional design matters.

4. **Build Your Platform Early**: Start building your author platform before your book launches.

5. **Understand Self-Publishing**: Learn about self-publishing options, formats, and platforms to maximize your book's potential.

6. **Create a Marketing Plan**: Marketing starts before publication day. Plan your strategy early.

7. **Network with Other Authors**: The writing community is supportive. Connect with fellow authors.

8. **Set Realistic Expectations**: Success rarely happens overnight. Be patient and persistent.

9. **Learn the Business Side**: Publishing is a business. Understand contracts, royalties, and rights.

10. **Keep Writing**: Your first book is just the beginning. Keep honing your craft.`
  },
  {
    id: 3,
    title: "The Complete Guide to Book Marketing in 2024",
    excerpt: "Discover the latest strategies and platforms that successful authors use to market their books effectively.",
    date: "March 10, 2024",
    category: "Marketing",
    image: "https://images.unsplash.com/photo-1542435503-956c469947f6?w=800",
    author: "Michael Chen",
    content: `Book marketing has evolved dramatically in recent years. Here's your complete guide to marketing success in 2024.

**Social Media Strategy**
Social media remains crucial for book marketing. Focus on platforms where your readers spend time - Instagram and TikTok for younger audiences, Facebook for older demographics.

**Email Marketing**
Building an email list gives you direct access to your readers. Offer a free chapter or bonus content to encourage sign-ups.

**Amazon Optimization**
Amazon is the world's largest bookstore. Optimize your book page with keywords, categories, and compelling descriptions.

**Book Reviews**
Positive reviews boost visibility and credibility. Reach out to book bloggers and reviewers in your genre.

**Content Marketing**
Create valuable content related to your book's themes. Blog posts, podcasts, and videos establish you as an authority.

**Paid Advertising**
Consider Amazon Ads, Facebook Ads, or BookBub promotions. Start small and scale what works.

**Launch Strategy**
Plan a coordinated launch with pre-orders, launch day promotions, and follow-up campaigns.

Remember: Marketing is ongoing, not a one-time event.`
  },
  {
    id: 4,
    title: "Print vs. Digital: Choosing the Right Format",
    excerpt: "Understanding the pros and cons of different publishing formats to make the best decision for your book.",
    date: "March 5, 2024",
    category: "Publishing",
    image: "https://images.unsplash.com/photo-1512820790803-83ca734da794?w=800",
    author: "Emily Rodriguez",
    content: `Choosing between print and digital formats is a crucial decision. Here's what you need to know.

**Print Books**
Pros: Tangible, collectable, better profit margins, preferred by certain demographics
Cons: Higher upfront costs, inventory management, shipping logistics

**E-books**
Pros: Lower price point, instant delivery, easy distribution, no inventory
Cons: Lower perceived value, pricing pressure, device dependency

**Audiobooks**
The fastest-growing format. Audiobooks reach commuters and multitaskers.

**The Best Approach**
Most successful authors publish in multiple formats. Readers have preferences, and offering options maximizes your potential audience.

**Format-Specific Considerations**
- Print: Focus on quality paper and binding
- E-book: Ensure proper formatting for all devices
- Audiobook: Invest in professional narration

The right choice depends on your genre, audience, and goals. Many authors find success with a multi-format approach.`
  },
  {
    id: 5,
    title: "How to Build an Author Platform Before Your Book Launch",
    excerpt: "Essential strategies for establishing your author presence and building an engaged audience.",
    date: "February 20, 2024",
    category: "Marketing",
    image: "https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=800",
    author: "Jennifer Lee",
    content: `Your author platform is your connection to readers. Build it early for maximum impact.

**Website Essentials**
A professional website serves as your online home. Include an author bio, book information, and blog.

**Social Media Presence**
Choose 2-3 platforms and be consistent. Quality engagement beats quantity.

**Email List**
Your most valuable asset. Offer incentives for sign-ups and nurture relationships.

**Content Creation**
Share valuable content related to your expertise and book themes.

**Networking**
Connect with other authors, join writing groups, attend literary events.

Start building your platform months before your book launch for the best results.`
  },
  {
    id: 6,
    title: "The Art of Writing Compelling Book Descriptions",
    excerpt: "Learn how to craft book descriptions that captivate readers and drive sales.",
    date: "February 15, 2024",
    category: "Writing Tips",
    image: "https://images.unsplash.com/photo-1471107340929-a87cd0f5b5f3?w=800",
    author: "Robert Williams",
    content: `Your book description is your sales pitch. Make every word count.

**Hook Them Immediately**
Start with a compelling opening that grabs attention in the first sentence.

**Show, Don't Tell**
Use specific details and vivid language rather than generic praise.

**Focus on Benefits**
What will readers gain? Transformation, entertainment, knowledge?

**Create Tension**
For fiction, hint at conflict without spoiling. For non-fiction, address pain points.

**Call to Action**
End with a clear invitation to buy or read more.

Test different versions and refine based on results.`
  },
  {
    id: 7,
    title: "Book Cover Design: Trends and Best Practices for 2024",
    excerpt: "Discover current design trends and timeless principles for creating eye-catching book covers.",
    date: "February 10, 2024",
    category: "Design",
    image: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=800",
    author: "Alexandra Santos",
    content: `Book covers sell books. Here's what's working in 2024.

**Current Trends**
Minimalist designs, bold typography, illustrated covers, photographic realism.

**Genre Conventions**
Understanding genre expectations helps readers identify your book quickly.

**Typography Matters**
Font choice communicates tone and genre. Invest in quality fonts.

**Color Psychology**
Colors evoke emotions. Choose palettes that match your book's mood.

**Professional vs DIY**
While tools exist for DIY covers, professional design usually wins in competitive markets.

Your cover is an investment in your book's success.`
  },
  {
    id: 8,
    title: "Understanding Book Royalties and Publishing Contracts",
    excerpt: "Navigate the financial aspects of publishing with confidence and avoid common pitfalls.",
    date: "February 5, 2024",
    category: "Business",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800",
    author: "Marcus Johnson",
    content: `Publishing contracts and royalties can be confusing. Let's demystify the numbers.

**Royalty Basics**
Royalties are your earnings per book sold. With self-publishing, you earn significantly more per book.

**Self-Publishing Royalties**
Up to 70% on Amazon for e-books priced $2.99-$9.99, and 60% on print books. Other retailers typically offer 60-70% royalties.

**Traditional Publishing Comparison**
Traditional publishers typically pay only 10-15% for print and 25% for e-books - that's why we focus on self-publishing to maximize your earnings.

**You Keep All Rights**
When you self-publish with us, you retain 100% ownership of your book including audio rights, foreign rights, and all other subsidiary rights.

**No Advance, But Higher Long-Term Earnings**
While traditional publishers may offer small advances, self-publishing gives you higher royalties from day one. Most authors earn significantly more through self-publishing over the lifetime of their book.

Always have a lawyer review contracts before signing.`
  },
  {
    id: 9,
    title: "How to Get Book Reviews: A Step-by-Step Guide",
    excerpt: "Proven strategies for acquiring honest reviews that boost your book's visibility and credibility.",
    date: "January 30, 2024",
    category: "Marketing",
    image: "https://images.unsplash.com/photo-1507842217343-583bb7270b66?w=800",
    author: "Lisa Anderson",
    content: `Book reviews are social proof. Here's how to get them ethically and effectively.

**Start with Your Network**
Reach out to friends, family, and colleagues who've read your book. Ask for honest reviews.

**Book Blogger Outreach**
Find bloggers in your genre. Send personalized pitches with review copies.

**Review Programs**
Services like NetGalley connect authors with reviewers.

**Social Media**
Share review request posts on your platforms. Make it easy for readers to leave reviews.

**Timing Matters**
Request reviews during launch period when momentum is highest.

**Never Buy Reviews**
Fake reviews violate platform policies and damage your reputation.

Focus on building genuine reader relationships.`
  },
  {
    id: 10,
    title: "Building a Sustainable Author Career: Long-Term Strategies",
    excerpt: "Think beyond your first book and build a lasting career as an author.",
    date: "January 25, 2024",
    category: "Business",
    image: "https://images.unsplash.com/photo-1516414447565-b14be0adf13e?w=800",
    author: "Thomas Baker",
    content: `One book won't build a career. Here's how to think long-term.

**Write More Books**
The best marketing for your current book is your next book. Build a backlist.

**Develop Multiple Revenue Streams**
Books, speaking engagements, courses, consulting - diversify your income.

**Build Your Brand**
You're not just selling books; you're building a brand. What do you want to be known for?

**Continuous Learning**
The publishing industry changes rapidly. Stay informed and adapt.

**Manage Your Business**
Track expenses, understand taxes, set professional systems.

**Take Care of Yourself**
Writing is a marathon, not a sprint. Sustainable practices prevent burnout.

**Plan Series and Sequels**
Series readers are loyal readers. Consider writing in series.

Success comes from consistent effort over time.`
  }
];

export const achievements = [
  { number: "500+", label: "Books Published" },
  { number: "300+", label: "Happy Authors" },
  { number: "98%", label: "Client Satisfaction" },
  { number: "50+", label: "Awards Won" }
];

// UPDATED VERSION 2025 NEW CATEGORIES
export const portfolioProjects = [
  // Children's Book
  {
    id: 1,
    title: "Strong Without, Strong Within",
    category: "Children's Book",
    genre: "Children's Book",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/nxd5m6bd_Children%20Book.jpg",
    description: "Story for Every Child. Families Are Different. Love is Enough",
    author: "Lola Daalioni",
    status: "Bestseller"
  },
  {
    id: 2,
    title: "Misha Elle & Mellie The Moo Cow",
    category: "Children's Book",
    genre: "Children's Book",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/3p9hpusu_Children%20Book%20%282%29.jpg",
    description: "A heartwarming story of friendship between a girl and her special pet",
    author: "Angela Value",
    status: "New Release"
  },
  {
    id: 3,
    title: "A LETTER ABOUT MICHAEL",
    category: "Children's Book",
    genre: "Children's Book",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/8932u38n_Children%20Book%20%283%29.jpg",
    description: "A touching children's story written by Manuel Cambó, edited by Matias Dovarganes, illustrations by Kechu",
    author: "Manuel Cambó",
    status: "Award Winner"
  },
  {
    id: 4,
    title: "WHO CARES ANYWAY?",
    category: "Children's Book",
    genre: "Children's Book",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/2gtp1ztx_Children%20Book%20%284%29.jpg",
    description: "A heartwarming children's story",
    author: "Lynn Sutton Pritchard-Dykes",
    status: "Published"
  },
  
  // Fiction Books
  {
    id: 5,
    title: "THE FALL OF THE IRELAND QUEEN",
    category: "Fiction",
    genre: "Fiction",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/st5buo1k_Fiction.jpg",
    description: "A story about an underwater adventure - a captivating historical fiction thriller",
    author: "Angela P. Erickson",
    status: "Bestseller"
  },
  {
    id: 6,
    title: "THE PINEWOOD PROWLER",
    category: "Fiction",
    genre: "Fiction",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/zw7n97pu_Fiction%20%282%29.jpg",
    description: "A gripping mystery set in the heart of the woods",
    author: "Audrey Zeigon",
    status: "Award Winner"
  },
  {
    id: 7,
    title: "A VINTAGE TO DIE FOR",
    category: "Fiction",
    genre: "Fiction",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/o5gcncpx_Fiction%20%283%29.jpg",
    description: "A Harlan Thane Mystery - a thrilling novella centered around rare vintage wines",
    author: "Joseph David Tappero",
    status: "Published"
  },
  {
    id: 8,
    title: "NEVER WALK ALONE",
    category: "Fiction",
    genre: "Fiction",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/zdd5i141_Fiction%284%29.png",
    description: "An emotional journey of resilience and finding strength in solitude",
    author: "Randal Smith",
    status: "Bestseller"
  },
  
  // Memoir Books
  {
    id: 9,
    title: "BREAKING THE SILENCE",
    category: "Memoir",
    genre: "Memoir",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/84mug1iq_Memoir.jpg",
    description: "How to Rise - An inspiring memoir of overcoming adversity",
    author: "Andrea Chaney-Lawrence",
    status: "Bestseller"
  },
  {
    id: 10,
    title: "STORIES FROM THE FARM",
    category: "Memoir",
    genre: "Memoir",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/fetg3kvt_memoir%20%282%29.jpg",
    description: "Heartwarming memories and life lessons from farm life",
    author: "Edward A. Sears",
    status: "Award Winner"
  },
  {
    id: 11,
    title: "WHEN FIRE TAUGHT US TO SPEAK",
    category: "Memoir",
    genre: "Memoir",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/8zon9yze_Memoir%20%283%29.png",
    description: "Love: Not Sin But Prophecy - A powerful spiritual memoir",
    author: "Barbara A. Owens",
    status: "Bestseller"
  },
  {
    id: 12,
    title: "GOD SAID YES",
    category: "Memoir",
    genre: "Memoir",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/htyjs86i_Memoir%20%284%29.jpg",
    description: "From a Fatal Diagnosis to a Divine Miracle",
    author: "Essig Sutton",
    status: "Published"
  },
  
  // Non-Fiction Books
  {
    id: 13,
    title: "OLD SWEET: HISTORY AND ANSWERS",
    category: "Non-Fiction",
    genre: "Non-Fiction",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/q6gui3z7_Non-Fiction.jpg",
    description: "Designed/Influenced by Thomas Jefferson - The Springs, The Hotel, The Sisters",
    author: "Arietta DuPre",
    status: "Bestseller"
  },
  {
    id: 14,
    title: "A BRIEF TEXT: THE HISTORY AND PHILOSOPHY OF ASTRONOMICAL THOUGHT",
    category: "Non-Fiction",
    genre: "Non-Fiction",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/7zy2fyxt_Non-Fiction%20%282%29.jpg",
    description: "The History and Philosophy of Astronomical Thought",
    author: "Michael Chriss",
    status: "Award Winner"
  },
  {
    id: 15,
    title: "CEASE FIRE",
    category: "Non-Fiction",
    genre: "Non-Fiction",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/b68n1en7_Non-Fiction%20%283%29.jpg",
    description: "How the Vietnam War was truly fought",
    author: "John M. Koelsch",
    status: "Published"
  },
  {
    id: 16,
    title: "JOURNEY OF FAITH: YOUNG BELIEVER'S SUCCESS STORY",
    category: "Non-Fiction",
    genre: "Non-Fiction",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/p1p1n0vw_Non%20Fiction%20%284%29.jpg",
    description: "Young Believer's Success Story - An inspiring spiritual journey",
    author: "Rev. Dr. David Gayflor Yogboh",
    status: "Classic"
  },
  
  // Poetry Books
  {
    id: 17,
    title: "MY AMISH ADVENTURES",
    category: "Poetry",
    genre: "Poetry",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/3amv1p03_Poetry%20%284%29.jpg",
    description: "My Life as an Amish Taxi Driver in Lancaster, Pennsylvania Volume 1",
    author: "Esther Kachel Sollenberger",
    status: "Bestseller"
  },
  {
    id: 18,
    title: "PETALS OF POETRY",
    category: "Poetry",
    genre: "Poetry",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/8m8r09vb_Poetry%20%282%29.jpg",
    description: "A beautiful collection of verses celebrating life and nature",
    author: "Sybil Shearin",
    status: "Published"
  },
  {
    id: 19,
    title: "POEMS 4 U",
    category: "Poetry",
    genre: "Poetry",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/jy4f85t0_Poetry%20%283%29.jpg",
    description: "Heartfelt verses connecting soul to soul",
    author: "Veronica A Odum",
    status: "New Release"
  },
  {
    id: 20,
    title: "UNHEALED WOUNDS",
    category: "Poetry",
    genre: "Poetry",
    image: "https://customer-assets.emergentagent.com/job_book-showcase-5/artifacts/fu70nkca_Poetry.jpg",
    description: "A powerful collection exploring pain, healing, and resilience",
    author: "Tamyah Cooper",
    status: "Award Winner"
  }
];

export const faqData = [
  {
    question: "How long does the publishing process take?",
    answer: "The timeline varies based on services selected, but typically ranges from 3-6 months from manuscript submission to publication."
  },
  {
    question: "Do you offer self-publishing services?",
    answer: "Yes, we specialize in comprehensive self-publishing services and hybrid models. Our team will help you choose the best package for your goals and budget."
  },
  {
    question: "Can I retain the rights to my book?",
    answer: "Absolutely. Author rights retention is a key part of our publishing agreements. You maintain full control of your intellectual property."
  },
  {
    question: "What genres do you specialize in?",
    answer: "We work with all genres including fiction, non-fiction, memoirs, business books, self-help, children's books, and more."
  },
  {
    question: "Do you provide international distribution?",
    answer: "Yes, we distribute to major platforms worldwide including Amazon, Barnes & Noble, Apple Books, and international retailers."
  }
];